export const INSTAGRAM_URL = 'https://www.instagram.com/hub30lb';
export const WHATSAPP_NUMBER = '96171077545';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const MAPS_URL = 'https://maps.app.goo.gl/MvXrPex3wcMZMbFS7';
